import { axiosInstance } from './axiosConfig.ts';

export interface SolicitudReserva {
  id: number;
  codigo: string;
  cliente_nombre: string;
  cliente?: number | null;
  contacto_cotizacion?: {
    nombre: string; apellido: string; email: string; telefono: string;
    ci_nit: string; empresa: string; observaciones: string; personas: number;
  } | null;
  sucursal: number;
  sucursal_nombre: string;
  precio_plan_servicio: number;
  servicio_nombre: string;
  espacio_servicio: number | null;
  espacio_nombre?: string | null;
  fecha_inicio: string;
  fecha_fin: string;
  hora_inicio: string;
  hora_fin?: string | null;
  cantidad_periodos: number;
  dias_habiles: boolean;
  estado: 'pendiente' | 'oficializada' | 'rechazada' | 'expirada';
  expira_en: string;
  cita_oficial?: number | null;
  sugerencia_origen?: number | null;
  whatsapp_url?: string | null;
}

export interface CrearSolicitudReserva {
  usar_horas_afiliado?: boolean;
  sucursal?: number;
  precio_plan_servicio: number;
  espacio_servicio: number | null;
  fecha_inicio: string;
  fecha_fin: string;
  hora_inicio: string;
  hora_fin?: string | null;
  cantidad_periodos: number;
  dias_habiles: boolean;
  cupon?: number | null;
}

const API_URL = 'solicitudes-reserva/';

export const listarSolicitudesReserva = async (): Promise<SolicitudReserva[]> => {
  const response = await axiosInstance.get<SolicitudReserva[]>(API_URL);
  return response.data;
};

export const crearSolicitudReserva = async (data: CrearSolicitudReserva): Promise<SolicitudReserva> => {
  const response = await axiosInstance.post<SolicitudReserva>(API_URL, data);
  return response.data;
};

/**
 * Ambas operaciones exigen la sesión POS EXPLÍCITA del operador: el backend
 * no infiere "la primera caja abierta" y valida que sea propia, abierta,
 * habilitada para citas y de la misma sucursal que la solicitud.
 */
export const buscarSolicitudReserva = async (codigo: string, sesionPosId: number): Promise<SolicitudReserva> => {
  const response = await axiosInstance.get<SolicitudReserva>(`${API_URL}buscar-por-codigo/`, {
    params: { codigo: codigo.trim().toUpperCase(), sesion_pos_id: sesionPosId },
  });
  return response.data;
};

/**
 * Oficializar crea una cita POS: además de la sesión explícita, el backend
 * exige el grant del operador identificado por PIN (``X-POS-Operator-Token``)
 * y atribuye la reserva a ese operador. Sin grant no se llama al servidor.
 */
export const oficializarSolicitudReserva = async (
  codigo: string,
  sesionPosId: number,
  operadorToken: string,
  clienteId?: number | null,
): Promise<any> => {
  if (!operadorToken) {
    throw new Error('Se requiere el grant del operador de caja (PIN) para oficializar la solicitud.');
  }
  const response = await axiosInstance.post(
    `${API_URL}oficializar/`,
    { codigo: codigo.trim().toUpperCase(), sesion_pos_id: sesionPosId, ...(clienteId ? { cliente_id: clienteId } : {}) },
    { headers: { 'X-POS-Operator-Token': operadorToken } },
  );
  return response.data;
};


export const obtenerSolicitudReserva = async (id: number): Promise<SolicitudReserva> =>
  (await axiosInstance.get<SolicitudReserva>(`${API_URL}${id}/`)).data;


